import { collectNumbers, maRibbonSeries, numericExtent } from "../utils";
const MARIBBON = {
    name: "MARibbon",
    compute: (bars, type = "EMA", periods) => {
        return maRibbonSeries(bars.map((b) => b.close), type, periods ?? undefined);
    },
    computeExtents: (values) => numericExtent(collectNumbers(values)),
    render: () => undefined,
};
export default MARIBBON;
